import * as React from 'react'
import MyComponentHelpers from '../MyComponent/Helpers'
import MyHelpers from './Helpers'
function MyBase(props: any) {
  const MyTypeFn = MyComponentHelpers.getMyComponentTypeFn(
    MyHelpers.Types,
    props
  )
  return <MyTypeFn {...props} />
}

export default MyBase
